export default __webpack_public_path__ + "static/media/logo-big.4ea00a03.jpg";